/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListServerClientAssociationsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListServerClientAssociationsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListServerClientAssociationsSecurity = {
  option1?: ListServerClientAssociationsSecurityOption1 | undefined;
  option2?: ListServerClientAssociationsSecurityOption2 | undefined;
};

export type ListServerClientAssociationsRequest = {
  /**
   * The MCP server.
   */
  mcpServerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListServerClientAssociationsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListServerClientAssociationsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListServerClientAssociationsSecurityOption1$Outbound,
    ListServerClientAssociationsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listServerClientAssociationsSecurityOption1ToJSON(
  listServerClientAssociationsSecurityOption1:
    ListServerClientAssociationsSecurityOption1,
): string {
  return JSON.stringify(
    ListServerClientAssociationsSecurityOption1$outboundSchema.parse(
      listServerClientAssociationsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListServerClientAssociationsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListServerClientAssociationsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListServerClientAssociationsSecurityOption2$Outbound,
    ListServerClientAssociationsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listServerClientAssociationsSecurityOption2ToJSON(
  listServerClientAssociationsSecurityOption2:
    ListServerClientAssociationsSecurityOption2,
): string {
  return JSON.stringify(
    ListServerClientAssociationsSecurityOption2$outboundSchema.parse(
      listServerClientAssociationsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListServerClientAssociationsSecurity$Outbound = {
  Option1?: ListServerClientAssociationsSecurityOption1$Outbound | undefined;
  Option2?: ListServerClientAssociationsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListServerClientAssociationsSecurity$outboundSchema: z.ZodMiniType<
  ListServerClientAssociationsSecurity$Outbound,
  ListServerClientAssociationsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListServerClientAssociationsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListServerClientAssociationsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listServerClientAssociationsSecurityToJSON(
  listServerClientAssociationsSecurity: ListServerClientAssociationsSecurity,
): string {
  return JSON.stringify(
    ListServerClientAssociationsSecurity$outboundSchema.parse(
      listServerClientAssociationsSecurity,
    ),
  );
}

/** @internal */
export type ListServerClientAssociationsRequest$Outbound = {
  mcp_server_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListServerClientAssociationsRequest$outboundSchema: z.ZodMiniType<
  ListServerClientAssociationsRequest$Outbound,
  ListServerClientAssociationsRequest
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listServerClientAssociationsRequestToJSON(
  listServerClientAssociationsRequest: ListServerClientAssociationsRequest,
): string {
  return JSON.stringify(
    ListServerClientAssociationsRequest$outboundSchema.parse(
      listServerClientAssociationsRequest,
    ),
  );
}
